export default __webpack_public_path__ + "static/O0128-aae84aab24ccba9bd995b6ffe5e3ce82.png";